// extracted by mini-css-extract-plugin
export var downArrow = "_a2-0";
export var infoTooltipIcon = "_a2-3";
export var label = "_a2-1";
export var optionCard = "_a2-4";
export var upArrow = "_a2-2";